import { useLayoutEffect } from 'react';

import { PaginatedDataResponse } from '../../api/types.js';
import { useImportHubNavigate } from '../../hooks/useImportHubRouteApi.js';
import {
  Table,
  TableContainer,
  type TableContainerProps,
  type TableProps,
} from './TableComponents.jsx';
import { TablePagination } from './TablePagination.jsx';

type PaginatedTableProps = TableProps & {
  data: PaginatedDataResponse<unknown>;
  isLoading?: boolean;
  tableContainerProps?: TableContainerProps;
};

export const PaginatedTable = ({
  data,
  tableContainerProps,
  isLoading,
  ...rest
}: PaginatedTableProps) => {
  const navigate = useImportHubNavigate();
  const { pageNumber, itemsPerPage, totalItems } = data;
  const lastPageNumber =
    totalItems === 0 ? 1 : Math.ceil(totalItems / itemsPerPage);

  const isInvalidPageNumber = lastPageNumber < pageNumber;

  useLayoutEffect(() => {
    if (isInvalidPageNumber) {
      navigate({
        search: (prevState) => ({
          ...prevState,
          pageNumber: lastPageNumber,
        }),
      } as Parameters<typeof navigate>[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInvalidPageNumber]);

  return (
    <>
      <TableContainer {...tableContainerProps}>
        <Table {...rest} />
      </TableContainer>
      <TablePagination data={data} />
    </>
  );
};
